import { initialSuggestSearchState } from '@modules/search/adapter/outbound/stores/suggestSearch.store';
import { IGetSuggestSearchUsecase } from '@modules/search/domain/ports/getSuggestSearch.usecase.port';
import { left, right } from '@shared/utils/either.utils';
import { ISuggestSearchRepository } from '../ports/suggestSearch.repository.port';
export class GetSuggestSearchUsecase implements IGetSuggestSearchUsecase {
  constructor(private readonly suggestSearchRepository: ISuggestSearchRepository) {}
  async handle(keyword: string): IGetSuggestSearchUsecase.getResultOutput {
    const result = await this.suggestSearchRepository.getResult(keyword);
    const value = result.value;
    if (result.isLeft()) {
      return left(initialSuggestSearchState);
    }
    return right(value);
  }
}